import React, { useEffect, useState } from "react";
import { SHOW_NOTIFICATION } from "action_creators/actioncreator";
//react 
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
// Formik

import { useFormik } from "formik";
// Material UI Components
import Button from "@material-ui/core/Button";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import {hotjar} from "react-hotjar";
import GridItem from "components/Grid/GridItem";
import Switch from "@material-ui/core/Switch";
//markdown editor
import MdEditor from 'react-markdown-editor-lite';
import MarkdownIt from 'markdown-it';
//markdown editor import style manually
import 'react-markdown-editor-lite/lib/index.css';
//API Call
import { CMSAPIWithToken } from "../../../apis/CMS";
//checkbox
import FormGroup from '@material-ui/core/FormGroup';
import Checkbox from '@material-ui/core/Checkbox';
import queryString from 'query-string';

const useStyles = makeStyles((theme) => ({
  
  gridContainer: {
    padding: "0 40px 30px 40px",
  },
  radioButton: {
    "& .MuiTypography-root": {
      marginLeft: "10px",
    },
  },
  formControl: {
    width: "100%",
    marginTop: "5px",
  },
  Select: {
    marginBottom: "50px",
  },
  warningNote: {
    "& .MuiAlert-icon": {
      display: "none",
    },
  },
  button: {
    marginTop: "50px",
  },
  buttOutlined: {
    color: theme.palette.buttonColor.main,
    borderColor: theme.palette.buttonColor.main,
    "&:hover": {
      border: `1px solid ${theme.palette.buttonColor.main}`,
    },
  },
}));

//sandbox view main
const SandboxesCategoriesView = (props) => {
  const classes = useStyles();
  hotjar.initialize(2281731, 6);
  hotjar.identify(localStorage.userName, { userProperty: localStorage.userName});
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState("");
  const [notificationType, setNotificationType] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const dispatch = useDispatch();
    const history = useHistory();
    const inputProps = {
        disableAnimation: true,
        shrink: false
      };  

  const formik = useFormik({
    enableReinitialize:true,
    initialValues: {
        admin_sandboxes_id: null,
        sandboxes_category_name: "",
        identifier: "",
        icon: "",
        category_position: null,
        is_enabled: true
              },
    onSubmit: (values) => {
      let payload = {
        admin_sandboxes_id: values.admin_sandboxes_id, 
        sandboxes_category_name: values.sandboxes_category_name,
        identifier: values.identifier,
        icon: values.icon,
        category_position:values.category_position
      };
    },
   
  });

 //mark down editor
function handleEditorChange({ html, text }) {
    //console.log('handleEditorChange', html, text);
  }
  // Initialize a markdown parser
  const mdParser = new MarkdownIt(/* Markdown-it options */);

  let data = [];

  const renderSanboxView = async () => {
    let queryParams = queryString.parse(window.location.search);
    var sb_id = queryParams.id;
    CMSAPIWithToken()
      .get(`/poc/admin_sandboxes_categories/?admin_sandboxes_id=${sb_id}`)
      .then((resp) => resp.data.results)
      .then((resp) => {
        resp.forEach((item) => {
          if(props.user == item.id) { 
            formik.setFieldValue("admin_sandboxes_id", item?.admin_sandboxes_id);
            formik.setFieldValue("sandboxes_category_name", item?.sandboxes_category_name);
            formik.setFieldValue("identifier", item?.identifier);
            formik.setFieldValue("icon", item?.icon);
            formik.setFieldValue("category_position", item?.category_position);
            formik.setFieldValue("created", item?.created);
            formik.setFieldValue("modified", item?.modified);
            formik.setFieldValue("is_enabled", item?.is_enabled ?? true);
          }
        });
      })
      .catch((err) => {
        let message = err.response.data.message;
        // setRows([]);
        // setIsLoading(false);
        setShowNotification(true);
        setNotificationType("error");
        setNotificationMessage("Failed to retrieve the data");
      });

      

      //setUserDetails({ ...formik.userDetails, ...data });
  };

  useEffect(() => {
    renderSanboxView();
  }, []);

  //checkbox
  
    const [state, setState] = React.useState({
      checkedA: true,
      checkedB: true,
      checkedF: true,
      checkedG: true,
    });

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  return (
    <div>
        <form
            onSubmit={formik.handleSubmit}
            className={classes.formContainer}
          >
      <Grid
        container
        justify="space-between"
        alignItems="center"
        className={classes.gridContainer}
      >
        <Grid item xs={12} md={5}>
          <Typography variant="h4">Sandbox Category view</Typography>
          
        </Grid>

        <Grid container className={classes.container}>
                <GridItem md={12} >
                  {formik.errors.admin_sandboxes_id && formik.touched.admin_sandboxes_id ? (
                    <TextField
                      type="text"
                      variant="filled"
                      label="Sandboxes Id"
                      name="admin_sandboxes_id"
                      fullWidth
                      InputLabelProps={inputProps}
                      value={formik.values.admin_sandboxes_iditle}
                      onChange={formik.handleChange}
                      helperText={formik.errors.admin_sandboxes_id}
                      onBlur={formik.handleBlur}
                      error
                    />
                  ) : (
                    <TextField
                      type="text"
                      variant="filled"
                      label="Sandboxes Id"
                      name="admin_sandboxes_id"
                      fullWidth
                      InputLabelProps={inputProps}
                      value={formik.values.admin_sandboxes_id}
                      onChange={formik.handleChange}
                    />
                  )}
                </GridItem>
                
                <GridItem md={12}>
                  <TextField
                    type="text"
                    variant="filled"
                    label="Sandboxes Category Name"
                    name="sandboxes_category_name"
                    fullWidth
                    InputLabelProps={inputProps}
                    value={formik.values.sandboxes_category_name}
                    onChange={formik.handleChange}
                  />
                </GridItem>

                <GridItem md={12}>
                  <TextField
                    type="text"
                    variant="filled"
                    label="Identifier"
                    name="identifier"
                    fullWidth
                    InputLabelProps={inputProps}
                    value={formik.values.identifier}
                    onChange={formik.handleChange}
                  />
                </GridItem>

                <GridItem md={12}>
                  <TextField
                    type="text"
                    variant="filled"
                    label="Icon"
                    name="icon"
                    fullWidth
                    InputLabelProps={inputProps}
                    value={formik.values.icon}
                    onChange={formik.handleChange}
                  />
                </GridItem>
                <GridItem md={12}>
                  {formik.errors.category_position && formik.touched.category_position ? (
                    <TextField
                      type="number"
                      variant="filled"
                      label="Category Position"
                      name="category_position"
                      fullWidth
                      InputLabelProps={inputProps}
                      value={formik.values.category_position}
                      onChange={formik.handleChange}
                      helperText={formik.errors.category_position}
                      onBlur={formik.handleBlur}
                      error
                    />
                  ) : (
                    <TextField
                      type="number"
                      variant="filled"
                      label="Category Position"
                      name="category_position"
                      fullWidth
                      InputLabelProps={inputProps}
                      value={formik.values.category_position}
                      onChange={formik.handleChange}
                    />
                  )}
                </GridItem>

                <GridItem md={12}>
                  <span>Is Enabled</span>
                  <FormControlLabel
                    control={<Checkbox checked={formik.values.is_enabled} disabled />}
                    name="is_enabled"
                  />
                </GridItem>

                <GridItem md={9}>
                <Grid item xs={12} sm={12} md={12}>
                  <p>Crated Date:{formik.values.created}</p>
                  <p>Modified Date:{formik.values.modified}</p>
                  </Grid>
                </GridItem>
              </Grid>
      </Grid>
      </form>       
    </div>
  );
};

export default SandboxesCategoriesView;
